export enum ShareTypes {
  ANONYMOUS = "ANONYMOUS",
  PERSONALISED = "PERSONALISED",
}
